import { Sun } from "lucide-react";

export const Logo = ({ variant = "dark" }) => {
  const primary = variant === "dark" ? "#0F382C" : "#FDFBF7";
  const accent = variant === "dark" ? "#B45309" : "#FEF3C7";
  return (
    <div className="flex items-center gap-2.5" data-testid="site-logo">
      <div
        className="relative w-9 h-9 rounded-xl flex items-center justify-center shrink-0"
        style={{ background: "#D97706" }}
      >
        <Sun className="w-5 h-5" strokeWidth={2.5} color="#FDFBF7" />
      </div>
      <div className="leading-tight">
        <div
          className="font-serif-display text-lg sm:text-xl font-semibold tracking-tight"
          style={{ color: primary }}
        >
          Jeremy <span className="font-normal italic opacity-80">with</span> ION Solar
        </div>
        <div
          className="text-[10px] uppercase tracking-[0.2em] font-mono-metric mt-0.5"
          style={{ color: accent }}
        >
          Virginia · Local Solar Guide
        </div>
      </div>
    </div>
  );
};

export default Logo;
